// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { ApolloLink, type FetchResult, Observable, type Operation } from '@apollo/client';
import type { QueryDeduplicator } from '@seedplanner/shared-graphql';
import { defer } from 'rxjs/internal/observable/defer';
import { from } from 'rxjs/internal/observable/from';
import { createQueryDeduplicator } from './createQueryDeduplicator';

export class HttpLink extends ApolloLink {
  private readonly queryDeduplicator: QueryDeduplicator;

  public constructor({ endpoint, labels }: { readonly endpoint: string; readonly labels: Record<string, string> }) {
    super();
    this.queryDeduplicator = createQueryDeduplicator({ endpoint, labels });
  }

  public request(operation: Operation): Observable<FetchResult> {
    const definition = operation.query.definitions.find((def) => def.kind === 'OperationDefinition');
    if (definition === undefined || definition.kind !== 'OperationDefinition') {
      throw new Error('Expected one operation');
    }

    const { variables } = operation;
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    const id: string = (operation.query as any).id;
    if (definition.operation === 'mutation') {
      return new Observable((subscriber) =>
        // biome-ignore lint/suspicious/noExplicitAny: <explanation>
        defer(async () => this.queryDeduplicator.execute({ id, variables })).subscribe(subscriber as any),
      );
    }

    const result$ = from(this.queryDeduplicator.execute({ id, variables }));

    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return new Observable((subscriber) => result$.subscribe(subscriber as any));
  }
}
